import { render } from "./OrderAddContainerModal.vue?vue&type=template&id=62570bb0&scoped=true&ts=true"
import script from "./OrderAddContainerModal.vue?vue&type=script&lang=ts"
export * from "./OrderAddContainerModal.vue?vue&type=script&lang=ts"

import "./OrderAddContainerModal.vue?vue&type=style&index=0&id=62570bb0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62570bb0"]])

export default __exports__